// thumb
import pf9 from '../images/porfolioImages/portfolio/thumb/project-9.png'
import pf10 from '../images/porfolioImages/portfolio/thumb/project-10.png'
import pf11 from '../images/porfolioImages/portfolio/thumb/project-11.png'
import pf12 from '../images/porfolioImages/portfolio/thumb/project-12.png'
import pf13 from '../images/porfolioImages/portfolio/thumb/project-13.png'
import pf14 from '../images/porfolioImages/portfolio/thumb/project-14.png'
import pf15 from '../images/porfolioImages/portfolio/thumb/project-15.png'
import pf16 from '../images/porfolioImages/portfolio/thumb/project-16.png'
import pf17 from '../images/porfolioImages/portfolio/thumb/project-17.png'
import pf18 from '../images/porfolioImages/portfolio/thumb/project-18.png'
import pf19 from '../images/porfolioImages/portfolio/thumb/project-19.png'
import pf20 from '../images/porfolioImages/portfolio/thumb/project-20.png'
import pf21 from '../images/porfolioImages/portfolio/thumb/project-21.png'
import pf22 from '../images/porfolioImages/portfolio/thumb/project-22.png'
import pf23 from '../images/porfolioImages/portfolio/thumb/project-23.png'
import pf24 from '../images/porfolioImages/portfolio/thumb/project-24.png'
import pf25 from '../images/porfolioImages/portfolio/thumb/project-25.png'
//large
import lg91 from "../images/porfolioImages/portfolio/large/project-9/1.png"
import lg92 from "../images/porfolioImages/portfolio/large/project-9/2.png"
import lg93 from "../images/porfolioImages/portfolio/large/project-9/3.png"
import lg94 from "../images/porfolioImages/portfolio/large/project-9/4.png"
import lg95 from "../images/porfolioImages/portfolio/large/project-9/5.png"
import lg96 from "../images/porfolioImages/portfolio/large/project-9/6.png"


import lg101 from "../images/porfolioImages/portfolio/large/project-10/1.png"
import lg102 from "../images/porfolioImages/portfolio/large/project-10/2.png"
import lg103 from "../images/porfolioImages/portfolio/large/project-10/3.png"
import lg104 from "../images/porfolioImages/portfolio/large/project-10/4.png"


import lg111 from "../images/porfolioImages/portfolio/large/project-11/1.png"
import lg112 from "../images/porfolioImages/portfolio/large/project-11/2.png"
import lg113 from "../images/porfolioImages/portfolio/large/project-11/3.png"
import lg114 from "../images/porfolioImages/portfolio/large/project-11/4.png"
import lg115 from "../images/porfolioImages/portfolio/large/project-11/5.png"


import lg121 from "../images/porfolioImages/portfolio/large/project-12/1.png"
import lg122 from "../images/porfolioImages/portfolio/large/project-12/2.png"
import lg123 from "../images/porfolioImages/portfolio/large/project-12/3.png"
import lg124 from "../images/porfolioImages/portfolio/large/project-12/4.png"


import lg131 from "../images/porfolioImages/portfolio/large/project-13/1.png"
import lg132 from "../images/porfolioImages/portfolio/large/project-13/2.png"
import lg133 from "../images/porfolioImages/portfolio/large/project-13/3.png"
import lg134 from "../images/porfolioImages/portfolio/large/project-13/4.png"
import lg135 from "../images/porfolioImages/portfolio/large/project-13/5.png"
import lg136 from "../images/porfolioImages/portfolio/large/project-13/6.png"


import lg141 from "../images/porfolioImages/portfolio/large/project-14/1.png"
import lg142 from "../images/porfolioImages/portfolio/large/project-14/2.png"
import lg143 from "../images/porfolioImages/portfolio/large/project-14/3.png"


import lg151 from "../images/porfolioImages/portfolio/large/project-15/1.png"
import lg152 from "../images/porfolioImages/portfolio/large/project-15/2.png"
import lg153 from "../images/porfolioImages/portfolio/large/project-15/3.png"


import lg161 from "../images/porfolioImages/portfolio/large/project-16/1.png"

import lg171 from "../images/porfolioImages/portfolio/large/project-17/1.png"

import lg181 from "../images/porfolioImages/portfolio/large/project-18/1.png"

import lg191 from "../images/porfolioImages/portfolio/large/project-19/1.png"
import lg192 from "../images/porfolioImages/portfolio/large/project-19/2.png"

import lg201 from "../images/porfolioImages/portfolio/large/project-20/1.png"

import lg211 from "../images/porfolioImages/portfolio/large/project-21/1.png"


import lg221 from "../images/porfolioImages/portfolio/large/project-22/1.png"
import lg222 from "../images/porfolioImages/portfolio/large/project-22/2.png"


import lg231 from "../images/porfolioImages/portfolio/large/project-23/1.png"
import lg232 from "../images/porfolioImages/portfolio/large/project-23/2.png"
import lg233 from "../images/porfolioImages/portfolio/large/project-23/3.png"
import lg234 from "../images/porfolioImages/portfolio/large/project-23/4.png"


import lg241 from "../images/porfolioImages/portfolio/large/project-24/1.png"
import lg242 from "../images/porfolioImages/portfolio/large/project-24/2.png"
import lg243 from "../images/porfolioImages/portfolio/large/project-24/3.png"
import lg244 from "../images/porfolioImages/portfolio/large/project-24/4.png"
import lg245 from "../images/porfolioImages/portfolio/large/project-24/5.png"
import lg246 from "../images/porfolioImages/portfolio/large/project-24/6.png"
import lg247 from "../images/porfolioImages/portfolio/large/project-24/7.png"
import lg248 from "../images/porfolioImages/portfolio/large/project-24/8.png"

import lg249 from "../images/porfolioImages/portfolio/large/project-24/9.png"
import lg2410 from "../images/porfolioImages/portfolio/large/project-24/10.png"
import lg2411 from "../images/porfolioImages/portfolio/large/project-24/11.png"
import lg2412 from "../images/porfolioImages/portfolio/large/project-24/12.png"

import lg251 from "../images/porfolioImages/portfolio/large/project-25/1.png"
import lg252 from "../images/porfolioImages/portfolio/large/project-25/2.png"
import lg253 from "../images/porfolioImages/portfolio/large/project-25/3.png"
import lg254 from "../images/porfolioImages/portfolio/large/project-25/4.png"
import lg255 from "../images/porfolioImages/portfolio/large/project-25/5.png"
import lg256 from "../images/porfolioImages/portfolio/large/project-25/6.png"
import lg257 from "../images/porfolioImages/portfolio/large/project-25/7.png"
import lg258 from "../images/porfolioImages/portfolio/large/project-25/8.png"
import lg259 from "../images/porfolioImages/portfolio/large/project-25/9.png"

import lg2510 from "../images/porfolioImages/portfolio/large/project-25/a1.png"
import lg2511 from "../images/porfolioImages/portfolio/large/project-25/a2.png"
import lg2512 from "../images/porfolioImages/portfolio/large/project-25/a3.png"




const portfolio=[
  {
    id:6,
    thumb:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1651678239/msbGeanologyProfilePics/applicationTracker1_ypxctj.png",
    larg:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1651678239/msbGeanologyProfilePics/applicationTracker1_ypxctj.png"+","+"https://res.cloudinary.com/msb-geneasocial/image/upload/v1651678296/msbGeanologyProfilePics/applicationTracker3_yj0bg6.png"+","+"https://res.cloudinary.com/msb-geneasocial/image/upload/v1651678284/msbGeanologyProfilePics/applicationTracker2_owmr9k.png",
    title:'Application Tracker',
    category:'web-application',
    tools:'html, css, javascript, React, Nodejs, MongoDB',
    client:'personal project',
    date:"April 01 2022",
    siteName:"https://msb-geneasocial.herokuapp.com/admin/application",
    siteLink:"https://msb-geneasocial.herokuapp.com/admin/application",
    gitHubLink:"https://github.com/mrsuber/family-social-site-pes-01",
    description:"This is an application for tracking aplications and scaning a company exicutive members, know about the vision of the company and more"
  },
  {
    id:6.8,
    thumb:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1651676188/msbGeanologyProfilePics/expenseTracker2_cnqslb.png",
    larg:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1651676188/msbGeanologyProfilePics/expenseTracker2_cnqslb.png"+","+"https://res.cloudinary.com/msb-geneasocial/image/upload/v1651676194/msbGeanologyProfilePics/expenseTracker1_xamosq.png",
    title:'Expense Tracker',
    category:'web-application',
    tools:'html, css, javascript, React, Nodejs, MongoDB',
    client:'personal project',
    date:"may 01 2022",
    siteName:"https://msb-geneasocial.herokuapp.com/admin/expense",
    siteLink:"https://msb-geneasocial.herokuapp.com/admin/expense",
    gitHubLink:"https://github.com/mrsuber/family-social-site-pes-01",
    description:"This is an expense tracker that track you income and expenditures and plot carts with respect to your finance"
  },
  {
    id:6.9,
    thumb:pf25,
    larg:lg252+","+lg251+","+lg253+","+lg254+","+lg255+","+lg256+","+lg257+","+lg258+","+lg259+","+lg2510+","+lg2511+","+lg2512,
    title:'Digital Experts',
    category:'web-application',
    tools:'html, css, javascript, React, Nodejs, MongoDB, React-native',
    client:'client project',
    date:"March 01 2022",
    siteName:"www.digitalExpert.com",
    siteLink:"https://digital-experts-app.herokuapp.com",
    gitHubLink:"https://github.com/mrsuber",
    description:"This was a client project so the link to github is mask. it dealt with user authentication app, snap Identity card and take passport and upload to the server. The server when admin log into, he can create new users, print the users information, export the entire database in either excel or pdf, view the details about any user and change admin password and mobile responsive"
  },
  {
    id:7,
    thumb:pf24,
    larg:lg242+","+lg241+","+lg243+","+lg244+","+lg245+","+lg246+","+lg247+","+lg248+","+lg249+","+lg2410+","+lg2411+","+lg2412,
    title:'Geneasocial',
    category:'web-application',
    tools:'html, css, javascript, React, Nodejs, MongoDB',
    client:'personal project',
    date:"Novermber 08 2021",
    siteName:"www.geneasocial.com",
    siteLink:"https://msb-geneasocial.herokuapp.com",
    gitHubLink:"https://github.com/mrsuber/family-social-site-pes-01",
    description:"Geneasocial is a secure social media site tailored only for Geneo students. This way students and instructors can privately socialize without the whole public being part of it making learning fun."
  },
  {
    id:8,
    thumb:pf23,
    larg:lg231+","+lg232+","+lg233+","+lg234,
    title:'Personal portfolio',
    category:'web-application',
    tools:'html, css, javascript, React',
    client:'personal project',
    date:"Aug 08 2021",
    siteName:"www.mohamad-profolio-version-03",
    siteLink:"https://msb-geneasocial.herokuapp.com/porfolio/home",
    gitHubLink:"https://github.com/mrsuber/family-social-site-pes-01",
    description:"This was my third porfolio site to showcase all the project i have worked on so far. it was build in React"
  },
  {
    id:9,
    thumb:pf9,
    larg:lg91+","+lg92+","+lg93+","+lg94+","+lg95+","+lg96,
    title:'Personal portfolio',
    category:'web-application',
    tools:'html, css, javascript, React',
    client:'personal project',
    date:"Aug 08 2021",
    siteName:"www.mohamad-profolio-version-01",
    siteLink:"https://my-portfolio-fc70b.web.app/",
    gitHubLink:"https://github.com/mrsuber/odin_project_14_cvBuilder",
    description:"This was my first porfolio site to showcase all the project i have worked on so far. it was build in React"
  },
  {
    id:10,
    thumb:pf10,
    larg:lg101+","+lg102+","+lg103+","+lg104,
    title:'Personal website',
    category:'web-application',
    tools:'html, css, javascript, React, Nodejs',
    client:'personal project',
    date:"Sept 21 2021",
    siteName:"www.mohamad-personal-web-version-01",
    siteLink:"https://my-personal-site-mern-stack.herokuapp.com/",
    gitHubLink:"https://github.com/mrsuber/my-porfolio-version2-mern-stack",
    description:"This was my website to not only showcase my porducts but to render other services as teaching. MERN-stack"
  },

  {
    id:11,
    thumb:pf11,
    larg:lg111+","+lg112+","+lg113+","+lg114+","+lg115,
    title:'Ecommerce website',
    category:'e-commerce',
    tools:'html, css, javascript, React',
    client:'personal project',
    date:"Aug 28 2021",
    siteName:"www.msb-shop-version-02",
    siteLink:"https://msb-shop-159bb.web.app/",
    gitHubLink:"https://github.com/mrsuber/Ecomerce-web-project",
    description:"Fully functional Ecommerce application using stripe for card transactions, creating interfaces using material ui, using the Commercejs Api "
  },

  {
    id:12,
    thumb:pf12,
    larg:lg121+","+lg122+","+lg123+","+lg124,
    title:'Dashbourd version 1',
    category:'dashbourd',
    tools:'html, css, javascript, React',
    client:'personal project',
    date:"Sept 04 2021",
    siteName:"www.msb-admin-version-01",
    siteLink:"https://dashboard-2a5f8.web.app/",
    gitHubLink:"https://github.com/mrsuber/Admin-dashboard",
    description:"React dashboard with analitic chart using active users per month,new members last transactions,display user list, edit users and create new user pages and products and more."
  },

  {
    id:13,
    thumb:pf13,
    larg:lg131+","+lg132+","+lg133+","+lg134+","+lg135+","+lg136,
    title:'Crypto Gratitude',
    category:'web-application',
    tools:'html, css, javascript, React,Redux',
    client:'personal project',
    date:"Sept 21 2021",
    siteName:"www.msb-cyptogratitude.com",
    siteLink:"https://cryptoverse-c9bc2.web.app/",
    gitHubLink:"https://github.com/mrsuber/Cryptocurency-react-app",
    description:"This is a Cryptocurency React application. indept data about all Cryptocurency, cryptoMarkets and Exchanges,popular Cryptocurency News and much more. interfaces created using Ant Design, charts are created using Chart.js. Fectch data form Rapid Api"
  },

  {
    id:14,
    thumb:pf14,
    larg:lg141+","+lg142+","+lg143,
    title:'Amazon Clone',
    category:'e-commerce',
    tools:'html, css, javascript, jquery React',
    client:'personal project',
    date:"Aug 07 2021",
    siteName:"www.msb-amazon-clone.com",
    siteLink:"https://e-chalange2.web.app/",
    gitHubLink:"https://github.com/mrsuber/Amazon-clone-React",
    description:"This is an Amazon clone with full Ecomerce functionality,using stripe account for demo payment"
  },

  {
    id:15,
    thumb:pf15,
    larg:lg151+","+lg152+","+lg153,
    title:'Resturant website',
    category:'web-application',
    tools:'html, css, javascript',
    client:'personal project',
    date:"June 30 2021",
    siteName:"www.msb-Resturant.com",
    siteLink:"https://mrsuber.github.io/odin_project_06_restaurant/",
    gitHubLink:"https://github.com/mrsuber/odin_project_06_restaurant",
    description:"This is a Resturant websit that gives you recipes to cook different meals as well as videos to aid your cooking"
  },

  {
    id:16,
    thumb:pf16,
    larg:lg161,
    title:'Rock Paper Scissors Game',
    category:'game',
    tools:'html, css, javascript',
    client:'personal project',
    date:"Sept 02 2021",
    siteName:"www.msb-rock-paper-scissors.com",
    siteLink:"https://mrsuber.github.io/rock-paper-sisors-game2.0/",
    gitHubLink:"https://github.com/mrsuber/rock-paper-sisors-game2.0/",
    description:"This is a Rock Paper Scissors game man VS computer"
  },

  {
    id:17,
    thumb:pf17,
    larg:lg171,
    title:'Tic Tac Toe Game',
    category:'game',
    tools:'html, css, javascript',
    client:'personal project',
    date:"June 22 2021",
    siteName:"www.msb-tic-tac-toe.com",
    siteLink:"https://mrsuber.github.io/odin_project_05_TicTacToe/",
    gitHubLink:"https://github.com/mrsuber/odin_project_05_TicTacToe",
    description:"This is a Tic-Tac-Toe game man VS computer"
  },

  {
    id:18,
    thumb:pf18,
    larg:lg181,
    title:'Task Tracker',
    category:'web-application',
    tools:'html, css, javascript Anglar',
    client:'personal project',
    date:"Aug 04 2021",
    siteName:"www.msb-task-tracker.com",
    siteLink:"https://modest-goldwasser-fe077f.netlify.app/",
    gitHubLink:"https://github.com/mrsuber/odin_project_13_Introduction_to_React/tree/master/task-app",
    description:"This is a task tracker that works with a json backend server"
  }

  ,

  {
    id:19,
    thumb:pf19,
    larg:lg191+","+lg192,
    title:'CV Creator',
    category:'web-application',
    tools:'html, css, javascript React',
    client:'personal project',
    date:"Aug 08 2021",
    siteName:"www.msb-cv-creator.com",
    siteLink:"https://my-portfolio-fc70b.web.app/cvbuilder",
    gitHubLink:"https://github.com/mrsuber/odin_project_14_cvBuilder",
    description:"This is a cv creator application to create and print your cv in mordern format"
  }  ,

    {
      id:20,
      thumb:pf20,
      larg:lg201,
      title:'Facebook Clone version1',
      category:'web-application',
      tools:'html, css, javascript React',
      client:'personal project',
      date:"Aug 16 2021",
      siteName:"www.msb-facebook-clone.com",
      siteLink:"https://facebook-clone-a97e2.web.app/",
      gitHubLink:"https://github.com/mrsuber/FaceBook-clone",
      description:"This is a facebook clone that implemented the OAuth 2.0 authentication"
    }
    ,

    {
      id:21,
      thumb:pf21,
      larg:lg211,
      title:'Netflix Clone version1',
      category:'web-application',
      tools:'html, css, javascript React',
      client:'personal project',
      date:"Aug 14 2021",
      siteName:"www.msb-netflix-clone.com",
      siteLink:"https://netflix-clone-8365e.web.app/",
      gitHubLink:"https://github.com/mrsuber/Netflix-clone",
      description:"This is a facebook clone that implemented the OAuth 2.0 authentication"
    },

    {
      id:22,
      thumb:pf22,
      larg:lg221+","+lg222,
      title:'Ecommerce Food website ',
      category:'e-commerce',
      tools:'html, css, javascript, React',
      client:'personal project',
      date:"Aug 28 2021",
      siteName:"www.msb-food shop-version-01",
      siteLink:"https://my-personal-site-mern-stack.herokuapp.com/prodject/ecommerce1",
      gitHubLink:"https://github.com/mrsuber/my-porfolio-version2-mern-stack",
      description:"Fully functional Ecommerce application Design "
    }

]

export default portfolio
